import DisplayPL from "./p&L";
import { Leg } from "./../../types";
import { calculateProfit } from "../../calculations/calculateProfits";
import InputField from "./../InputField";
import PositionTable from "./table";

interface AnalyzeProps {
  strategy: Leg[];
  positionFields: any[];
  expectedExpiryValue: string;
  expectedExpiryValueChanged: Function;
}

export const ExpiryAnalysis = ({
  expectedExpiryValue,
  expectedExpiryValueChanged,
  strategy,
  positionFields,
}: AnalyzeProps) => {
  const expiryValue = parseFloat(expectedExpiryValue);
  return (
    <div>
      <b style={{paddingLeft: "10px"}}>Expected expiry value</b>
      <InputField
        type="number"
        value={expectedExpiryValue}
        placeholder="(optional)"
        onValueChange={expectedExpiryValueChanged}
      ></InputField>

      {expectedExpiryValue.length > 0 && expiryValue > 0 && (
        <>
          <DisplayPL value={calculateProfit(strategy, expiryValue)}></DisplayPL>
          <PositionTable
            dataSource={strategy}
            fields={positionFields}
            showRemoveIcon={false}
          ></PositionTable>
        </>
      )}
    </div>
  );
};
